<template>
  <el-form
    ref="form"
    :model="formData"
    :rules="formRules"
    label-suffix="："
    label-width="100px"
  >
    <el-form-item label="" label-width="0" prop="content">
      <el-input
        v-model.trim="formData.content"
        type="textarea"
        :placeholder="`请输入${tipText}内容`"
        :rows="4"
      />
    </el-form-item>
    <el-form-item label="相关附件">
      <upload
        ref="uploadFile"
        class="upload-file"
        :file-id-before.sync="relatedFileIds"
        :props-data="{
          bizType: 'objection',
          attachmentType: 'objection_related_attachment',
          uploadMode: 'fileId',
          limit: 10
        }"
      >
        <el-button slot="btn" plain>
          <div class="text-center" style="width: 100%;">
            <span class="iconfont icon-upload"></span>
            点击上传
          </div>
        </el-button>
      </upload>
    </el-form-item>
    <el-form-item label="" label-width="0">
      <el-button type="primary" @click="handleSubmit">
        提交{{ tipText }}
      </el-button>
      <el-button plain @click="handleCancel">取消</el-button>
    </el-form-item>
  </el-form>
</template>
<script>
// 组件
import Upload from '@/components/common/Upload/index'

// 数据字典
import { workbenchServiceDict } from '@/dictionary/system'

// 工具
import { requiredRule } from '@/utils/form-validate'

export default {
  components: {
    Upload
  },
  props: {
    type: {
      type: [String, Number],
      default: workbenchServiceDict.PURCHASER.value
    }
  },
  data() {
    return {
      workbenchServiceDict,

      formData: {
        content: '',
        attachmentIds: []
      },
      formRules: {
        content: requiredRule('请输入内容')
      }
    }
  },

  computed: {
    // 上传附件
    relatedFileIds: {
      get() {
        return (this.formData.attachmentIds || []).join(',')
      },
      set(val) {
        if (val?.length) {
          this.formData.attachmentIds = val.split(',')
        } else {
          this.formData.attachmentIds = []
        }
      }
    },

    tipText() {
      return this.type === workbenchServiceDict.SUPPLIER.value ? '异议' : '答复'
    }
  },

  methods: {
    handleCancel() {
      this.$emit('cancel')
    },

    async handleSubmit() {
      const valid = await this.$refs.form.validate()
      if (!valid) return

      this.$confirm(`是否确认提交?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.$emit('submit', this.formData)
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.upload-file {
  ::v-deep .file-list {
    margin-bottom: 8px;
    padding-left: 16px;
    padding-right: 16px;
    background: $body-background-color;
    border-radius: 4px;
  }
}
</style>
